var cartUpsellFlickitySlider;

var upsellMainProductSlider = new Flickity( '.main-product-upsell-slider', {
  cellAlign: 'left',
  contain: true,
  pageDots: false
});

var reviewSnippetInterval = setInterval( function () {
  if($('.main-product-upsell-slider .ruk_rating_snippet[data-done]').length > 0) {
    upsellMainProductSlider.resize();
    clearInterval(reviewSnippetInterval);
  }
}, 1000);


$(document).on('click', '.product-upsell-toggle', function () {
  cartUpsellFlickitySlider.resize();
  
  var accordionToggleElement = $(this).next('.product-upsell-content');
  var accordionToggleHeight = accordionToggleElement.find('.product-upsell-content-wrapper').innerHeight();
  
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    accordionToggleElement.css('height', 0);
  } else {
    $(this).addClass('active');
    accordionToggleElement.css('height', accordionToggleHeight);
  }
});

$(document).on('click', '.upsell-product-addcart-btn', function () {
  var productId = $(this).data('product-id');
  var popover = $(`#product-upsell-popover-${productId}`);
  
  $('body').addClass('popover-opened');
  popover.addClass('is-opened');
  popover.next('.product-upsell-popover-mask').addClass('is-visibled');
});

$(document).on('click', '.product-upsell-popover-close, .product-upsell-popover-mask', function () {
  $('body').removeClass('popover-opened');
  $('.product-upsell-popover').removeClass('is-opened');
  $('.product-upsell-popover-mask').removeClass('is-visibled');
});

function updateUpsellImage(variant, productForm) {
  var productImage = productForm.find('.grid-product__image img');

  if (variantImages[variant.id] != '') productImage.attr('src', variantImages[variant.id]);
}

function updateUpsellPrice(variant, productForm) {
  var productPrice = productForm.find('.grid-product__price');
  
  var priceHTML = `<span class="original-price">${theme.Currency.formatMoney(variant.price,theme.settings.moneyFormat).replace('.',',').trim()}</span>`;
  
  if (variant.compare_at_price) {
    priceHTML = `<span class="compare-price">${theme.Currency.formatMoney(variant.compare_at_price,theme.settings.moneyFormat).replace('.',',').trim()}</span>
                 <span class="original-price on-sale">${theme.Currency.formatMoney(variant.price,theme.settings.moneyFormat).replace('.',',').trim()}</span>`;
  }

  productPrice.html(priceHTML);
}

function updateUpsellAddCartBtn(variant, productForm) {
  var productAddBtn = productForm.find('.btn-upsell-add');
  
  productForm.find('[name="id"]').val(variant.id);
  
  if (variant.available) {
    productAddBtn.removeAttr('disabled');
    productAddBtn.removeClass('disabled');
    productAddBtn.find('span').text(theme.strings.addCart);
  } else {
    productAddBtn.attr('disabled', 'disabled');
    productAddBtn.addClass('disabled');
    productAddBtn.find('span').text(theme.strings.soldOut);
  }
}

$(document).on('click', '.grid-product__option-item', function () {
  $(this).addClass('checked').siblings('.grid-product__option-item').removeClass('checked');

  var productForm = $(this).closest('.product-upsell-popover-form');

  if (productForm.find('.grid-product__option-item.checked').length) {
    var variantJson = productForm.find('[type="application/json"]')[0].innerHTML;
    var variantData = JSON.parse(variantJson);
    
    selectedVariantOptions = [];
    
    productForm.find('.grid-product__option-item.checked').each( function () {
      selectedVariantOptions.push($(this).attr('value'))
    });
  
    var currentVariant = variantData.find(function(variant, index) {
      return (selectedVariantOptions.length == variant.options.length) && variant.options.every(function(variantOption, index2) {
        if (variantOption === selectedVariantOptions[index2]) {
          return variant;
        }
      });
    });

    updateUpsellImage(currentVariant, productForm);
    updateUpsellPrice(currentVariant, productForm);
    updateUpsellAddCartBtn(currentVariant, productForm);
  }
});

$(document).on('click', '.product-upsell-popover .btn-upsell-add', function (event) {
  event.preventDefault();

  var productForm = $(this).closest('.product-upsell-popover-form');
  var productFormBtn = productForm.find('.btn-upsell-add');
  
  var productId = productForm.find('[name="id"]').val();

  productFormBtn.addClass('btn--loading');
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: productId
    },
    dataType: 'json', 
    success: function (product) {
      
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product
        }
      }));
      
      productFormBtn.removeClass('btn--loading');

      $('body').removeClass('popover-opened');
      $('.product-upsell-popover').removeClass('is-opened');
      $('.product-upsell-popover-mask').removeClass('is-visibled');
    },
    error: function (obj, status) {
      var responseErrorText = $.parseJSON(obj.responseText);
      
      productFormBtn.removeClass('btn--loading');

      $('.product-upsell-popover-error').text(responseErrorText.description);
      setTimeout( function () {
        $('.product-upsell-popover-error').text('');
      }, 3000);
    }
  });
});
